import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from './../../shared/pipes/safe-html.pipe';
import { FolderFilterPipe } from './../../shared/pipes/folder-filter.pipe';
import { MyFilterPipe } from './../../shared/pipes/my-filter.pipe';
import { FilterUniqueNamePipe } from './../../shared/pipes/unique-name.pipe';
import { TruncatePipe } from './../../shared/pipes/truncate.pipe';
import { ReversePipe } from './../../shared/pipes/reverse.pipe';
import { OrderByPipe } from './../../shared/pipes/order-by.pipe';
import { ConvertFrom24To12FormatPipe } from './../../shared/pipes/convert-from24-to12-format.pipe';
import { TimeAgoPipe } from './../../shared/pipes/time-ago.pipe';
/* import { MailContentComponent } from './../../mailbox/mail-content/mail-content.component'; */
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CustomInputComponent } from './../../shared/custom-input/custom-input.component';
import { BreadcrumbComponent } from './../../breadcrumb/breadcrumb.component';
import { RouterModule } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { faStackOverflow, faGithub, faMedium, faFlipboard } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { AirportFormComponent } from '../../masters/airport/airport-form/airport-form.component';
import { DoctorFormComponent } from '../../masters/doctor/doctor-form/doctor-form.component';
import { HospitalFormComponent } from '../../masters/hospital/hospital-form/hospital-form.component';
import { MedicineFormComponent } from '../../masters/medicine/medicine-form/medicine-form.component';
import { LabtestFormComponent } from '../../masters/labtest/labtest-form/labtest-form.component';
import { RoomtypeFormComponent } from '../../masters/roomtype/roomtype-form/roomtype-form.component';
import { SurgeryFormComponent } from '../../masters/surgery/surgery-form/surgery-form.component';
import { VesselFormComponent } from '../../masters/vessel/vessel-form/vessel-form.component';
import { RankFormComponent } from '../../masters/rank/rank-form/rank-form.component';
import { CompanyFormComponent } from '../../masters/company/company-form/company-form.component';
import { UserFormComponent } from '../../masters/users/user-form/user-form.component';
import { MailTemplateFormComponent } from '../../masters/mail-template/mail-template-form/mail-template-form.component';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import {
	faRedoAlt, faRedo, faSync, faMale, faFemale, faSquare, faCheckSquare, faMedkit, faAmbulance, faBrain, faShip, faHome, faPowerOff, faLock, faCloudDownloadAlt, faSpinner, faTh, faAngleDown, faAngleUp, faTimes, faUser, faUsers, faEnvelope, faBookMedical, faFileMedical, faFileMedicalAlt, faPumpMedical, faNotesMedical, faClinicMedical, faLaptopMedical, faCommentMedical, faBriefcaseMedical, faHandHoldingMedical, faCheck, faMinus, faCalendar, faCalendarAlt, faCalendarWeek, faFilter, faPlus, faPencilAlt, faTrash, faKey, faUserAlt, faUserPlus, faUserCircle, faCapsules, faTablet, faTablets, faTabletAlt, faSave, faSignOutAlt, faHelicopter, faBuilding, faFlag, faDatabase, faCity, faEye, faEyeSlash, faStar, faInfo, faInfoCircle, faChalkboard, faFlagCheckered, faEdit, faUpload, faFileExcel, faFileVideo, faFilePdf, faFileImage, faFileArchive, faFileAudio, faTimesCircle, faFile, faPhone, faRupeeSign, faPrint, faLockOpen, faDownload, faListOl, faSun, faMoon, faExclamationTriangle, faExclamationCircle, faTrashAlt, faLink, faUnlink, faUserMd, faGraduationCap, faAward, faSchool, faSortDown, faSortUp, faSort, faSortAlphaDown, faSortAlphaUp, faSortAlphaDownAlt, faSortAlphaUpAlt, faHospital, faPhoneAlt, faThList, faCalendarDay, faFlask, faAngleDoubleUp, faHandsHelping, faHandshake, faInbox, faPaperPlane, faEnvelopeOpen, faSyncAlt,
	faSearch,
	faUndo,
	faSearchPlus,
	faSearchMinus,
	faArrowLeft,
	faArrowRight,
	faMicrophone,
	faArrowAltCircleLeft,
	faArrowAltCircleRight,
	faArrowCircleDown,
	faArrowCircleUp,
	faArrowUp,
	faArrowDown,
	faReply,
	faCalendarPlus,
	faCloudUploadAlt,
	faPaperclip,
	faExclamation,
	faFileWord,
	faFileCsv,
	faFileAlt,
	faCog,
	faSignature,
	faListAlt,
	faVideo,
	faVideoSlash,
	faMicrophoneSlash,
	faComment,
	faFillDrip,
	faImage,
	faPaintRoller,
	faLayerGroup,
	faAdjust,
	faPlayCircle,
	faCopy,
	faFileInvoice, faWheelchair, faPills, faMoneyBill, faMoneyCheck, faCalendarCheck,
	faPhoneSlash,
	faClock,
	faCalendarTimes,
	faUserShield,
	faShieldAlt,
	faCamera,
	faEraser,
	faBone,
	faHands,
	faHandPointer,
	faHeadSideVirus,
	faHandSparkles,
	faUserTie,
	faList,
	faTasks
} from '@fortawesome/free-solid-svg-icons';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatetimepickerModule, MatNativeDatetimeModule } from '@mat-datetimepicker/core';
import { NgbModule, NgbDatepickerModule, NgbDateAdapter, NgbDateNativeAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DataTablesModule } from 'angular-datatables';
import { NgToggleModule } from 'ng-toggle-button';
import { NgxFileDropModule } from 'ngx-file-drop';
import { QuillModule } from 'ngx-quill';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FileIconComponent } from '../file-icon/file-icon.component';
import { FilePreviewComponent } from '../file-preview/file-preview.component';
import { SafeUrlPipe } from '../pipes/safe-url.pipe';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { environment } from '../../../environments/environment';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { provideCharts, withDefaultRegisterables, BaseChartDirective } from 'ng2-charts';
import { SpinnerComponent } from '../spinner/spinner.component';
import { MailDirIconComponent } from '../mail-dir-icon/mail-dir-icon.component';
import { ViewAttachmentsComponent } from '../../mailbox/view-attachments/view-attachments.component';
import { TagInputModule } from 'ngx-chips';
import { MailDisplayComponent } from '../../mailbox/mail-display/mail-display.component';
import { FileUploaderComponent } from '../../mailbox/file-uploader/file-uploader.component';
import { MailFormComponent } from '../../mailbox/mail-form/mail-form.component';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { CallIconComponent } from '../call-icon/call-icon.component';
import { TreatmentCostFormComponent } from '../../case-management/quotation/treatment-cost-form/treatment-cost-form.component';
import { CustomDateParserFormatter } from '../date-parser/custom-date-parser';
import { WebcamModule } from 'ngx-webcam';

@NgModule({
	declarations: [
		SafeHtmlPipe,
		FolderFilterPipe,
		TruncatePipe,
		MyFilterPipe,
		ReversePipe,
		FilterUniqueNamePipe,
		OrderByPipe,
		ConvertFrom24To12FormatPipe,
		TimeAgoPipe,
		/* MailContentComponent, */
		CustomInputComponent,
		BreadcrumbComponent,
		FileIconComponent,
		FilePreviewComponent,
		SafeUrlPipe,
		UserFormComponent,
		CompanyFormComponent,
		VesselFormComponent,
		RankFormComponent,
		RoomtypeFormComponent,
		SurgeryFormComponent,
		LabtestFormComponent,
		HospitalFormComponent,
		MedicineFormComponent,
		DoctorFormComponent,
		AirportFormComponent,
		FileUploadComponent,
		SpinnerComponent,
		MailDirIconComponent,
		ViewAttachmentsComponent,
		MailDisplayComponent,
		FileUploaderComponent,
		MailFormComponent,
		CallIconComponent,
		TreatmentCostFormComponent,
		MailTemplateFormComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		MatFormFieldModule,
		RouterModule,
		FontAwesomeModule,
		MatInputModule,
		MatProgressBarModule,
		ReactiveFormsModule,
		HttpClientModule,
		ToastrModule.forRoot(),
		MatRadioModule,
		MatAutocompleteModule,
		NgbModule,
		MatDatepickerModule,
		MatDatetimepickerModule,
		MatNativeDateModule,
		MatNativeDatetimeModule,
		MatTooltipModule,
		MatExpansionModule,
		MatCardModule,
		MatIconModule,
		MatDividerModule,
		MatButtonModule,
		MatSlideToggleModule,
		MatSelectModule,
		MatTableModule,
		MatProgressSpinnerModule,
		DataTablesModule,
		NgToggleModule,
		MatButtonToggleModule,
		MatToolbarModule,
		NgSelectModule,
		MatCheckboxModule,
		NgxFileDropModule,
		QuillModule.forRoot(),
		MatMenuModule,
		NgxChartsModule,
		MatPaginatorModule,
		MatGridListModule,
		NgbDatepickerModule,
		MatChipsModule,
		NgMultiSelectDropDownModule.forRoot(),
		PdfViewerModule,
		ScrollingModule,
		provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
		provideFirestore(() => getFirestore()),
		provideAuth(() => getAuth()),
		provideMessaging(() => getMessaging()),
		AutocompleteLibModule,
		ImageCropperModule,
		BaseChartDirective,
		TagInputModule,
		WebcamModule
	],
	exports: [
		SafeHtmlPipe,
		FolderFilterPipe,
		TruncatePipe,
		MyFilterPipe,
		ReversePipe,
		FilterUniqueNamePipe,
		OrderByPipe,
		ConvertFrom24To12FormatPipe,
		TimeAgoPipe,
		/* MailContentComponent, */
		MatFormFieldModule,
		CustomInputComponent,
		BreadcrumbComponent,
		RouterModule,
		FontAwesomeModule,
		MatInputModule,
		MatProgressBarModule,
		ReactiveFormsModule,
		FormsModule,
		HttpClientModule,
		ToastrModule,
		MatRadioModule,
		MatAutocompleteModule,
		NgbModule,
		MatDatepickerModule,
		MatDatetimepickerModule,
		MatNativeDateModule,
		MatNativeDatetimeModule,
		MatTooltipModule,
		MatExpansionModule,
		MatCardModule,
		MatIconModule,
		MatDividerModule,
		MatButtonModule,
		MatSlideToggleModule,
		MatSelectModule,
		MatTableModule,
		MatProgressSpinnerModule,
		DataTablesModule,
		NgToggleModule,
		MatButtonToggleModule,
		MatToolbarModule,
		NgSelectModule,
		MatCheckboxModule,
		NgxFileDropModule,
		QuillModule,
		MatMenuModule,
		NgxChartsModule,
		MatPaginatorModule,
		MatGridListModule,
		NgbDatepickerModule,
		MatChipsModule,
		NgMultiSelectDropDownModule,
		FileIconComponent,
		FilePreviewComponent,
		SafeUrlPipe,
		PdfViewerModule,
		ScrollingModule,
		UserFormComponent,
		CompanyFormComponent,
		VesselFormComponent,
		RankFormComponent,
		RoomtypeFormComponent,
		SurgeryFormComponent,
		LabtestFormComponent,
		HospitalFormComponent,
		MedicineFormComponent,
		DoctorFormComponent,
		AirportFormComponent,
		AutocompleteLibModule,
		FileUploadComponent,
		ImageCropperModule,
		BaseChartDirective,
		SpinnerComponent,
		MailDirIconComponent,
		ViewAttachmentsComponent,
		TagInputModule,
		MailDisplayComponent,
		FileUploaderComponent,
		MailFormComponent,
		CallIconComponent,
		TreatmentCostFormComponent,
		WebcamModule,
		MailTemplateFormComponent
	],
	providers: [
		{ provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
		{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
		provideCharts(withDefaultRegisterables())
	],
})
export class CommonImportsModule {
	constructor(library: FaIconLibrary) {
		library.addIcons(
			faCalendarCheck, faMoneyCheck, faMoneyBill, faPills, faWheelchair, faFileInvoice, faPlayCircle, faPaintRoller, faLayerGroup, faAdjust, faImage, faFillDrip, faComment, faMicrophoneSlash, faVideoSlash, faVideo, faListAlt, faSignature, faCog, faFileAlt, faFileCsv, faFileWord, faExclamation, faPaperclip, faCloudUploadAlt, faCalendarPlus, faReply, faArrowUp, faArrowDown, faArrowCircleUp, faArrowCircleDown, faArrowAltCircleLeft, faArrowAltCircleRight, faMicrophone, faArrowLeft, faArrowRight, faFlipboard, faSearchPlus, faSearchMinus, faRedo, faUndo, faSearch, faRedoAlt, faRedo, faUserPlus, faUserCircle, faSync, faMale, faFemale, faStackOverflow, faGithub, faMedium, faSquare, faCheckSquare, faMedkit, faAmbulance, faBrain, faShip, faHome, faPowerOff, faLock, faCloudDownloadAlt, faSpinner, faTh, faAngleDown, faAngleUp, faTimes, faUser, faUsers, faUserAlt, faEnvelope, faBookMedical, faFileMedical, faFileMedicalAlt, faPumpMedical, faNotesMedical, faClinicMedical, faLaptopMedical, faCommentMedical, faBriefcaseMedical, faHandHoldingMedical, faCheck, faMinus, faCalendar, faCalendarAlt, faCalendarWeek, faFilter, faPlus, faPencilAlt, faTrash, faLock, faKey, faCapsules, faTablet, faTablets, faTabletAlt, faSave, faSignOutAlt, faHelicopter, faBuilding, faFlag, faDatabase, faCity, faEye, faEyeSlash, faStar, faCalendar, faInfo, faInfoCircle, faChalkboard, faFlagCheckered, faEdit, faUpload, faFileExcel, faFileVideo, faFilePdf, faFileImage, faFileArchive, faFileAudio, faTimesCircle, faFile, faPhone, faRupeeSign, faPrint, faLockOpen, faDownload, faSignOutAlt, faListOl, faSun, faMoon, faExclamationTriangle, faExclamationCircle, faTrashAlt, faLink, faUnlink, faUserMd, faGraduationCap, faAward, faSchool, faSortDown, faSortUp, faSort, faSortAlphaDown, faSortAlphaUp, faSortAlphaDownAlt, faSortAlphaUpAlt, faHospital, faPhoneAlt, faTh, faThList, faCalendarDay, faFlask, faAngleDoubleUp, faHandsHelping, faHandshake, faInbox, faPaperPlane, faEnvelopeOpen, faSyncAlt, faCloudDownloadAlt, faCopy, faPhoneSlash, faClock, faCalendarTimes, faUserShield, faShieldAlt, faCamera, faEraser, faBone, faHands, faHandPointer, faHeadSideVirus, faHandSparkles, faPhoneSlash, faUserTie, faList, faTasks
		);
	}
}
